import React from 'react';
import { View, Text, SafeAreaView, TouchableOpacity, StyleSheet, Alert } from 'react-native';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';
import * as Clipboard from 'expo-clipboard';
import { ArrowLeft, Copy } from 'lucide-react-native';

export default function PixPage() {
  const router = useRouter();
  const { colors } = useTheme();
  const params = useLocalSearchParams();
  const chave = typeof params.chave === 'string' ? params.chave : '';

  const copiar = async () => {
    if (!chave) {
      Alert.alert('Aviso', 'Nenhuma chave PIX encontrada.');
      return;
    }
    await Clipboard.setStringAsync(chave);
    Alert.alert('Copiado!', 'Chave PIX copiada para a área de transferência.');
  };

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 24,
      paddingVertical: 16,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
      backgroundColor: colors.surface,
      gap: 12,
    },
    backButton: {
      width: 40,
      height: 40,
      borderRadius: 12,
      backgroundColor: colors.primary + '15',
      alignItems: 'center',
      justifyContent: 'center',
    },
    headerTitle: {
      fontSize: 18,
      fontFamily: 'Inter-SemiBold',
      color: colors.text,
    },
    content: {
      padding: 24,
      gap: 16,
    },
    card: {
      backgroundColor: colors.surface,
      borderRadius: 16,
      borderWidth: 1,
      borderColor: colors.border,
      padding: 20,
      gap: 8,
    },
    label: {
      fontSize: 12,
      fontFamily: 'Inter-SemiBold',
      color: colors.textSecondary,
      textTransform: 'uppercase',
      letterSpacing: 1,
    },
    value: {
      fontSize: 16,
      fontFamily: 'Inter-Medium',
      color: colors.text,
    },
    button: {
      backgroundColor: colors.primary,
      borderRadius: 14,
      paddingVertical: 14,
      paddingHorizontal: 16,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
    },
    buttonText: {
      color: '#fff',
      fontFamily: 'Inter-SemiBold',
      fontSize: 16,
    },
  });

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity style={styles.backButton} onPress={() => router.back()} activeOpacity={0.8}>
          <ArrowLeft size={18} color={colors.primary} />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Chave PIX</Text>
      </View>

      <View style={styles.content}>
        <View style={styles.card}>
          <Text style={styles.label}>Chave</Text>
          <Text style={styles.value}>{chave || 'Nenhuma chave informada'}</Text>
        </View>

        <TouchableOpacity style={styles.button} onPress={copiar} activeOpacity={0.9}>
          <Copy size={18} color="#fff" />
          <Text style={styles.buttonText}>Copiar chave</Text>
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  );
}

